(() => {
  'use strict';
  
  const C=window.ELEVENINE_CATALOG, Cart=window.ELEVENINE_CART;
  const root=document.querySelector('[data-product-page]'); if(!root)return;
  const params=new URLSearchParams(location.search);
  const nativeProduct=window.ELEVENINE_NATIVE_PRODUCT||null;
  const product=C.bySlug(nativeProduct?.handle)||C.bySlug(params.get('slug'))||C.byId(params.get('id'));
  if(!product){root.innerHTML='<div class="empty-state"><h1>PRODUCTO NO ENCONTRADO.</h1><p>La ficha solicitada no existe.</p><a class="button button-yellow" href="/#productos">VOLVER AL CATÁLOGO</a></div>';return;}
  const hasShopifyPrice=Boolean(nativeProduct&&Array.isArray(nativeProduct.variants)&&nativeProduct.variants.some(variant=>Number(variant.price)>0));
  const isCarpas=Number(product.id)===11;
  const isStark=product.category==='STARK VARG';
  const isQuoteOnly=Boolean(product.quoteOnly&&!hasShopifyPrice);
  if(nativeProduct&&!isQuoteOnly&&!product.launch&&!isCarpas&&!isStark){product.stock=Boolean(nativeProduct.available);}
  const isSurronAccessory=product.category==='Accesorios SUR-RON';
  root.classList.toggle('is-carpas-product',isCarpas);
  root.classList.toggle('is-stark-product',isStark);
  root.classList.toggle('is-quote-product',isQuoteOnly);
  root.classList.toggle('is-surron-accessory-product',isSurronAccessory);
  const requestedModel=params.get('modelo');
  const modelOptions=product.variants?.Modelo||[];
  const lockedModel=product.category==='SUR-RON'&&modelOptions.length
    ?(modelOptions.includes(requestedModel)?requestedModel:(product.defaultSelections?.Modelo||modelOptions[0]))
    :null;
  const surronYear=lockedModel||(/^\d{4}$/.test(String(product.year||''))?String(product.year):'');
  const displayName=lockedModel?`${product.name} ${lockedModel}`:product.name;
  const hyperBeeAgeNotice=Number(product.id)===22?'<div class="hyper-bee-product-notice"><b>MODELO INFANTIL</b><span>Ideal para niños de 7 a 10 años</span><small>Diseñada para pilotos jóvenes. Revisa talla, experiencia y supervisión antes de comprar.</small></div>':'';
  const lockedModelDetail=lockedModel?product.modelYearDetails?.[lockedModel]:null;
  const lockedModelPromo=lockedModel?window.ELEVENINE_SURRON_PROMOS?.[`${product.id}:${lockedModel}`]||null:null;
  const initialNativePriceLabel=()=>{
    if(!lockedModel)return C.priceLabel(product);
    const nativeProduct=window.ELEVENINE_NATIVE_PRODUCT||{};
    const optionNames=Array.isArray(nativeProduct.options)?nativeProduct.options:[];
    const modelIndex=optionNames.findIndex(name=>String(name||'').trim().toLocaleLowerCase('es-MX')==='modelo');
    if(modelIndex<0)return C.priceLabel(product);
    const prices=(Array.isArray(nativeProduct.variants)?nativeProduct.variants:[])
      .filter(variant=>String(variant.options?.[modelIndex]??'').trim()===String(lockedModel))
      .map(variant=>Number(variant.price))
      .filter(Number.isFinite);
    if(!prices.length)return C.priceLabel(product);
    const minimum=Math.min(...prices)/100;
    const maximum=Math.max(...prices)/100;
    return minimum===maximum?C.money(minimum):`${C.money(minimum)} – ${C.money(maximum)}`;
  };
  const promoMarkup=lockedModelPromo?`
    <div class="product-promo" aria-label="${C.escapeHTML(lockedModelPromo.label)}">
      <span class="product-promo-label">${C.escapeHTML(lockedModelPromo.label)}</span>
      <div class="product-promo-meta">
        <span>Antes <del>${C.money(lockedModelPromo.previousPrice)}</del></span>
        <strong>Bono de ${C.money(lockedModelPromo.bonus)}</strong>
      </div>
      ${Array.isArray(lockedModelPromo.conditions)&&lockedModelPromo.conditions.length?`<small>${lockedModelPromo.conditions.map(C.escapeHTML).join(' · ')}</small>`:''}
    </div>`:'';
  const formatInventoryLabel=quantity=>{
    const count=Math.max(0,Number(quantity)||0);
    if(!count)return'';
    return `${count} ${count===1?'unidad disponible':'unidades disponibles'}`;
  };
  const preorderRule=()=>{
    const model=String(lockedModel||selections.Modelo||product.year||'').trim();
    const color=String(selections.Color||'').trim();
    if(Number(product.id)===32&&model==='2026'&&['Verde','Morado'].includes(color)){
      return {
        label:'PREVENTA',
        note:`Color ${color} disponible en preventa. Aparta con <strong>$50,000 MXN</strong>.`,
        cta:'APARTAR EN PREVENTA'
      };
    }
    if(Number(product.id)===34){
      return {
        label:'PREVENTA',
        note:'Modelo disponible en preventa. Aparta con <strong>$50,000 MXN</strong>.',
        cta:'APARTAR EN PREVENTA'
      };
    }
    return null;
  };
  const currentNativeVariant=()=>{
    const nativeProduct=window.ELEVENINE_NATIVE_PRODUCT||{};
    const nativeVariants=Array.isArray(nativeProduct.variants)?nativeProduct.variants:[];
    const optionNames=Array.isArray(nativeProduct.options)?nativeProduct.options:[];
    const normalize=value=>String(value??'').trim().toLocaleLowerCase('es-MX').replace('blanco/naranja','blanco/rojo');
    const selectedOptionNames=optionNames.filter(name=>String(selections?.[name]??'').trim());
    const matchingVariants=selectedOptionNames.length
      ?nativeVariants.filter(variant=>selectedOptionNames.every(name=>{
        const optionIndex=optionNames.indexOf(name);
        return normalize(variant.options?.[optionIndex])===normalize(selections[name]);
      }))
      :[];
    return matchingVariants.find(variant=>variant.available)
      ||matchingVariants[0]
      ||nativeVariants.find(variant=>String(variant.id)===String(nativeProduct.selectedVariantId))
      ||nativeVariants.find(variant=>variant.available)
      ||nativeVariants[0]
      ||null;
  };
  const selectedAvailabilityState=()=>{
    const variant=currentNativeVariant();
    const preorder=preorderRule();
    if(preorder){
      return {
        mode:'preorder',
        label:preorder.label,
        note:preorder.note,
        cta:preorder.cta,
        variant
      };
    }
    const qty=Number(variant?.inventoryQuantity);
    if(Number.isFinite(qty)&&qty>0){
      return {
        mode:'in',
        label:'EN EXISTENCIA',
        note:`<strong>${formatInventoryLabel(qty)}</strong>`,
        variant
      };
    }
    if(variant?.available){
      return {
        mode:'in',
        label:'EN EXISTENCIA',
        note:'Disponible para compra inmediata.',
        variant
      };
    }
    return {
      mode:'out',
      label:product.launch?'NUEVO LANZAMIENTO':'AGOTADO',
      note:product.launch?'Consulta disponibilidad y siguiente llegada con ELEVENINE.':'Consulta próxima llegada y disponibilidad con ELEVENINE.',
      variant
    };
  };
  const nativeDescription=String(window.ELEVENINE_NATIVE_PRODUCT?.description||'')
    .replace(/\s+/g,' ')
    .trim();
  const displayDescription=nativeDescription
    ||product.shopifyDescription
    ||(lockedModel&&lockedModelDetail?.summary?lockedModelDetail.summary:product.description);
  const displayShortDescription=product.shopifyShortDescription||product.shortDescription;
  const specificationEntries=lockedModel
    ?[
      ['Modelo',lockedModel],
      ...Object.entries(product.specifications||{}).filter(([key])=>
        key!=='Año de catálogo'&&
        key!=='Modelos disponibles'&&
        !key.startsWith('Colores ')
      ),
      ['Colores',product.specifications?.[`Colores ${lockedModel}`]||'Consulta disponibilidad con ELEVENINE']
    ]
    :Object.entries(product.specifications||{});
  const primaryVideo=lockedModel
    ?(product.modelDefaultVideos?.[lockedModel]||product.video)
    :product.video;
  document.title=displayName+' | ELEVENINE®';
  const selections=lockedModel?{Modelo:lockedModel}:{};let qty=1;
  const galleryVideos=(product.galleryVideos||[]).map(item=>{
    const video=typeof item==='string'?{src:item}:item;
    return {type:'video',src:video.src,label:video.label||'Video adicional'};
  });
  const videoMedia=[...(primaryVideo?[{type:'video',src:primaryVideo,label:'Video principal'}]:[]),...galleryVideos];
  const imageMedia=(product.gallery||[]).map(src=>({type:'image',src}));
  const media=videoMedia.length
    ?(product.includeGalleryImagesWithVideo?[...videoMedia,...imageMedia]:videoMedia)
    :imageMedia;
  let activeMedia=0;
  const mediaMarkup=item=>item.type==='video'
    ?`<video class="product-main-video" data-product-video muted loop playsinline preload="auto" aria-label="${C.escapeHTML(item.label||'Video de producto')} de ${C.escapeHTML(product.name)}"><source src="${C.escapeHTML(item.src)}" type="video/mp4"></video>`
    :`<img data-main-image src="${C.escapeHTML(item.src)}" alt="${C.escapeHTML(product.name)}">`;
  const brand=product.category==='SUR-RON'||product.category==='Accesorios SUR-RON'
    ?{src:window.ELEVENINE_THEME_ASSET("asset:a4f687e30942"),alt:'SUR-RON'}
    :(product.category==='STARK VARG'
      ?{src:window.ELEVENINE_THEME_ASSET("asset:cc731637469b"),alt:'STARK FUTURE'}
      :(product.category==='Goggles'?{src:window.ELEVENINE_THEME_ASSET("asset:0d44a651fae7"),alt:'ELEVENINE'}:null));
  const brandMark=brand?`<div class="product-brand-mark"><span>MARCA OFICIAL</span><img src="${brand.src}" alt="${brand.alt}"></div>`:'';
  const brochureLink=product.brochure
    ?`<a class="product-brochure-link" href="${C.escapeHTML(product.brochure)}" target="_blank" rel="noopener">VER BROCHURE COMPLETO <span aria-hidden="true">↗</span></a>`
    :'';
  const initialAvailability=selectedAvailabilityState();
  const status=isQuoteOnly
    ?'<span class="stock-pill launch" data-stock-pill>CONSULTAR DISPONIBILIDAD</span>'
    :`<span class="stock-pill ${initialAvailability.mode==='preorder'?'preorder':(initialAvailability.mode==='in'?'in':(product.launch?'launch':'out'))}" data-stock-pill>${C.escapeHTML(initialAvailability.label)}</span>`;
  const variants=Object.entries(product.variants||{})
    .filter(([label])=>!(lockedModel&&label==='Modelo'))
    .map(([label,options])=>`<fieldset class="variant-field" data-variant="${C.escapeHTML(label)}"><legend>${C.escapeHTML(label)} <span data-variant-value></span></legend><div class="variant-options">${options.map(v=>`<button type="button" class="variant-option" data-value="${C.escapeHTML(v)}">${C.escapeHTML(v)}</button>`).join('')}</div></fieldset>`).join('');
  const lockedModelBadge=lockedModel?`
    <div class="locked-model-generation" aria-label="Modelo SUR-RON ${C.escapeHTML(lockedModel)}">
      <span>MODELO SUR-RON</span>
      <strong>${C.escapeHTML(lockedModel)}</strong>
      <small>Configuración y colores exclusivos de esta generación</small>
    </div>`:'';
  const gogglesCustomizer=product.customizableGoggles?`
    <section class="goggle-customizer" data-goggle-customizer hidden aria-labelledby="goggle-customizer-title">
      <div class="goggle-customizer-copy">
        <span class="customizer-kicker">PERSONALIZACIÓN EN VIVO</span>
        <h2 id="goggle-customizer-title">HAZLOS TUYOS.</h2>
        <p>Agrega tu nombre, número, apodo o combina nombre y número. La vista previa representa cómo lucirá la personalización sobre la correa.</p>
      </div>
      <div class="goggle-preview-stage" data-goggle-theme="negro">
        <div class="goggle-preview-strap">
          <span>ELEVENINE</span>
          <strong data-custom-preview aria-live="polite">237</strong>
          <span>ELEVENINE</span>
        </div>
      </div>
      <div class="personalization-kind" role="group" aria-label="Tipo de personalización">
        ${['Nombre','Número','Apodo','Nombre + número'].map((kind,index)=>`<button type="button" class="${index===1?'active':''}" data-personal-kind="${kind}">${kind==='Nombre + número'?'NOMBRE<br>+ NÚMERO':C.escapeHTML(kind)}</button>`).join('')}
      </div>
      <label class="personalization-input">
        <span data-personal-label>NÚMERO PARA LA CORREA</span>
        <input type="text" maxlength="12" autocomplete="off" placeholder="Ej. 237" data-personal-text>
        <small>Máximo 12 caracteres. Confirmaremos el diseño final contigo.</small>
      </label>
      <label class="personalization-input personalization-input-secondary" data-personal-secondary hidden>
        <span>NÚMERO PARA LA CORREA</span>
        <input type="text" maxlength="3" inputmode="numeric" autocomplete="off" placeholder="Ej. 237" data-personal-number>
        <small>Hasta 3 dígitos. Puedes combinarlo con el nombre elegido.</small>
      </label>
    </section>`:'';
  root.innerHTML=`
    <div class="product-breadcrumb"><a href="/">Inicio</a><span>/</span><a href="/?categoria=${encodeURIComponent(product.category)}#productos">${C.escapeHTML(product.group)}</a><span>/</span><span>${C.escapeHTML(displayName)}</span></div>
    <section class="product-main">
      <div class="product-gallery">
        <div class="product-main-image" data-main-media>${mediaMarkup(media[0])}</div>
        ${media.length>1?`<div class="product-thumbs">${media.map((item,i)=>`<button class="product-thumb ${i===0?'active':''}" data-media-index="${i}" aria-label="${item.type==='video'?C.escapeHTML(item.label||'Ver video'):'Ver imagen '+(i+1)}">${item.type==='video'?`<span class="video-thumb-tile"><b>▶</b><small>${C.escapeHTML(item.label||'VIDEO')}</small></span>`:`<img src="${C.escapeHTML(item.src)}" alt="Vista ${i+1} de ${C.escapeHTML(product.name)}">`}</button>`).join('')}</div>`:''}
      </div>
      <div class="product-info">
        ${brandMark}
        <span class="eyebrow-dark">${C.escapeHTML(product.category)}</span>
        <h1>${C.escapeHTML(displayName)}</h1>
        ${isStark?'':`${lockedModelPromo?'<span class="product-promo-now">AHORA</span>':''}<div class="product-price">${initialNativePriceLabel()}</div>${promoMarkup}`}
        ${status}
        <div class="availability-note ${initialAvailability.mode==='preorder' ? 'is-preorder' : ''}" data-availability-note>${initialAvailability.note||''}</div>
        ${hyperBeeAgeNotice}
        <p class="product-lead">${C.escapeHTML(displayShortDescription)}</p>
        ${brochureLink}
        ${Array.isArray(product.price)&&!lockedModel?`<p class="price-note">${isCarpas?'El precio final se confirma con un asesor según medida, materiales, impresión y configuración elegida.':'El total del carrito usa el precio base publicado. La configuración final se confirma con un asesor.'}</p>`:''}
        ${lockedModelBadge}
        <div class="variant-stack">${variants}</div>
        ${product.modelYearDetails?`<section class="model-year-panel" data-model-year-panel hidden aria-live="polite">
          <small data-model-year-kicker>CONFIGURACIÓN SUR-RON</small>
          <h2 data-model-year-title></h2>
          <p data-model-year-summary></p>
          <ul data-model-year-highlights></ul>
          <p class="model-year-note" data-model-year-note hidden></p>
        </section>`:''}
        ${gogglesCustomizer}
        ${isCarpas||isStark||isQuoteOnly?'':`<div class="quantity-row"><span>CANTIDAD</span><div class="quantity"><button type="button" data-qty="-1" aria-label="Restar">−</button><output data-qty-value>1</output><button type="button" data-qty="1" aria-label="Sumar">+</button></div></div>`}
        <p class="form-error" data-product-error role="alert"></p>
        <div class="product-actions" data-product-actions></div>
        <div class="trust-grid"><div><b>ENVÍOS NACIONALES</b><span>Seguimiento del pedido</span></div><div><b>GARANTÍA ELEVENINE</b><span>Respaldo de marca</span></div><div><b>COMPRA PROTEGIDA</b><span>Checkout seguro con Shopify</span></div><div><b>ASESORÍA DIRECTA</b><span>Atención especializada</span></div></div>
      </div>
    </section>
    <section class="product-detail-grid">
      <div class="product-detail-intro"><span class="section-kicker">CONOCE EL PRODUCTO</span><h2>HECHO PARA<br><mark>SEGUIR RODANDO.</mark></h2><p class="variant-description" data-product-description aria-live="polite">${C.escapeHTML(displayDescription)}</p></div>
      <div class="accordion-list">
        <details><summary>ESPECIFICACIONES</summary><dl>${specificationEntries.map(([k,v])=>`<div><dt>${C.escapeHTML(k)}</dt><dd>${C.escapeHTML(v)}</dd></div>`).join('')}</dl></details>
        <details><summary>ENVÍOS</summary><p>${C.escapeHTML(product.shipping)}</p></details>
        <details><summary>GARANTÍA</summary><p>${C.escapeHTML(product.warranty)}</p></details>
        <details><summary>CUIDADOS</summary><p>${C.escapeHTML(product.care)}</p></details>
      </div>
    </section>
    <section class="benefit-band"><div>${product.benefits.map((b,i)=>`<article><span>0${i+1}</span><h3>${C.escapeHTML(b)}</h3></article>`).join('')}</div></section>
    <section class="related-section"><span class="section-kicker">MÁS PARA TU RODADA</span><h2>TAMBIÉN TE PUEDE<br><mark>INTERESAR.</mark></h2><div class="related-grid" data-related></div></section>`;
  const mainMedia=root.querySelector('[data-main-media]');
  const productGallery=root.querySelector('.product-gallery');
  const productInfo=root.querySelector('.product-info');
  const productDetailGrid=root.querySelector('.product-detail-grid');
  const syncProductDetailSpacing=()=>{
    if(!productGallery||!productInfo||!productDetailGrid)return;
    const desktop=window.matchMedia('(min-width:1121px)').matches;
    const lift=desktop?Math.max(0,productInfo.offsetHeight-productGallery.offsetHeight):0;
    productDetailGrid.style.setProperty('--product-detail-lift',`${Math.round(-lift)}px`);
  };
  if('ResizeObserver' in window){
    const productLayoutObserver=new ResizeObserver(syncProductDetailSpacing);
    productLayoutObserver.observe(productGallery);
    productLayoutObserver.observe(productInfo);
  }
  window.addEventListener('resize',syncProductDetailSpacing,{passive:true});
  requestAnimationFrame(syncProductDetailSpacing);
  const activateMedia=index=>{
    activeMedia=index;
    mainMedia.innerHTML=mediaMarkup(media[activeMedia]);
    root.querySelectorAll('[data-media-index]').forEach(b=>b.classList.remove('active'));
    root.querySelector(`[data-media-index="${activeMedia}"]`)?.classList.add('active');
  };
  root.querySelectorAll('[data-media-index]').forEach(btn=>btn.addEventListener('click',()=>activateMedia(Number(btn.dataset.mediaIndex))));
  const errorMessage=root.querySelector('[data-product-error]');
  const customizer=root.querySelector('[data-goggle-customizer]');
  const customInput=root.querySelector('[data-personal-text]');
  const customNumber=root.querySelector('[data-personal-number]');
  const customSecondary=root.querySelector('[data-personal-secondary]');
  const customPreview=root.querySelector('[data-custom-preview]');
  const customLabel=root.querySelector('[data-personal-label]');
  const modelYearPanel=root.querySelector('[data-model-year-panel]');
  const productDescription=root.querySelector('[data-product-description]');
  const normalizeNativeOption=value=>String(value??'')
    .trim()
    .toLocaleLowerCase('es-MX')
    .replace('blanco/naranja','blanco/rojo');
  const selectedNativeVariant=()=>{
    const nativeProduct=window.ELEVENINE_NATIVE_PRODUCT||{};
    const nativeVariants=Array.isArray(nativeProduct.variants)?nativeProduct.variants:[];
    const optionNames=Array.isArray(nativeProduct.options)?nativeProduct.options:[];
    const selectedOptionNames=optionNames.filter(name=>String(selections[name]??'').trim());
    const matchingVariant=selectedOptionNames.length
      ?nativeVariants.find(variant=>selectedOptionNames.every(name=>{
        const optionIndex=optionNames.indexOf(name);
        return normalizeNativeOption(variant.options?.[optionIndex])===normalizeNativeOption(selections[name]);
      }))
      :null;
    return matchingVariant
      ||nativeVariants.find(variant=>String(variant.id)===String(nativeProduct.selectedVariantId))
      ||nativeVariants[0]
      ||null;
  };
  const syncVariantDescription=()=>{
    if(!productDescription)return;
    const variantDescription=String(selectedNativeVariant()?.description||'').trim();
    productDescription.textContent=variantDescription||displayDescription;
    productDescription.dataset.descriptionSource=variantDescription?'variant':'product';
  };
  const syncQuoteLink=()=>{
    const quoteLink=root.querySelector('[data-quote-link]');
    if(!quoteLink)return;
    const selected=Object.entries(selections).map(([label,value])=>`${label}: ${value}`).join(' · ');
    const message=`Hola ELEVENINE, quiero cotizar ${product.name} de la línea Accesorios SUR-RON.${selected?` Mi selección es ${selected}.`:''} ¿Me ayudan a confirmar precio, compatibilidad y disponibilidad?`;
    quoteLink.href=`https://wa.me/523327052074?text=${encodeURIComponent(message)}`;
  };
  const syncModelYearPanel=()=>{
    if(!modelYearPanel)return;
    const year=String(selections.Modelo||product.year||Object.keys(product.modelYearDetails||{})[0]||'');
    const detail=product.modelYearDetails?.[year];
    if(!detail){
      modelYearPanel.hidden=true;
      return;
    }
    modelYearPanel.querySelector('[data-model-year-kicker]').textContent=`CONFIGURACIÓN SUR-RON · ${year}`;
    modelYearPanel.querySelector('[data-model-year-title]').textContent=detail.title||product.name;
    modelYearPanel.querySelector('[data-model-year-summary]').textContent=detail.summary||'';
    modelYearPanel.querySelector('[data-model-year-highlights]').innerHTML=(detail.highlights||[])
      .map(item=>`<li>${C.escapeHTML(item)}</li>`).join('');
    const note=modelYearPanel.querySelector('[data-model-year-note]');
    note.textContent=detail.note||'';
    note.hidden=!detail.note;
    modelYearPanel.hidden=false;
  };
  const personalizedVersion=()=>String(selections['Versión']||'').toUpperCase().includes('PERSONALIZADO');
  const setPersonalizationKind=kind=>{
    if(!customizer)return;
    selections['Tipo de personalización']=kind;
    customizer.querySelectorAll('[data-personal-kind]').forEach(button=>button.classList.toggle('active',button.dataset.personalKind===kind));
    const combined=kind==='Nombre + número';
    if(customSecondary)customSecondary.hidden=!combined;
    if(customLabel)customLabel.textContent=(combined?'Nombre para la correa':kind+' para la correa').toUpperCase();
    if(customInput)customInput.placeholder=kind==='Número'?'Ej. 237':(kind==='Nombre'||combined?'Ej. Alberto':'Ej. NINE');
    syncPersonalization();
  };
  const syncPersonalization=()=>{
    if(!customizer)return;
    const kind=selections['Tipo de personalización']||'Número';
    const primary=customInput?.value.trim()||'';
    const number=(customNumber?.value||'').replace(/\D/g,'').slice(0,3);
    if(customNumber&&customNumber.value!==number)customNumber.value=number;
    if(primary)selections.Personalización=primary;
    else delete selections.Personalización;
    if(kind==='Nombre + número'&&number)selections['Número personalizado']=number;
    else delete selections['Número personalizado'];
    if(customPreview){
      const combined=kind==='Nombre + número';
      customPreview.classList.toggle('is-combined',combined);
      if(combined){
        const previewName=(primary||'NOMBRE').toUpperCase();
        const previewNumber=(number||'237').toUpperCase();
        const nameSize=Math.max(.28,Math.min(.58,4.5/Math.max(previewName.length,6)));
        customPreview.style.setProperty('--preview-name-size',`${nameSize}em`);
        customPreview.innerHTML=`<span class="preview-name">${C.escapeHTML(previewName)}</span><span class="preview-number">${C.escapeHTML(previewNumber)}</span>`;
      }else{
        customPreview.style.removeProperty('--preview-name-size');
        customPreview.textContent=(primary||'237').toUpperCase();
      }
      customPreview.classList.remove('is-updating');
      void customPreview.offsetWidth;
      customPreview.classList.add('is-updating');
    }
    errorMessage.textContent='';
  };
  const syncCustomizer=()=>{
    if(!customizer)return;
    if(!personalizedVersion()){
      customizer.classList.remove('is-visible');
      customizer.hidden=true;
      delete selections['Tipo de personalización'];
      delete selections.Personalización;
      delete selections['Número personalizado'];
      return;
    }
    const version=String(selections['Versión']).toUpperCase();
    const theme=version.includes('BLANCO')?'blanco':(version.includes('ROJO')?'rojo':'negro');
    customizer.querySelector('[data-goggle-theme]').dataset.goggleTheme=theme;
    customizer.hidden=false;
    if(!selections['Tipo de personalización'])setPersonalizationKind('Número');
    requestAnimationFrame(()=>customizer.classList.add('is-visible'));
  };
  const syncVariantDependencies=()=>{
    Object.entries(product.variantDependencies||{}).forEach(([dependentLabel,configuration])=>{
      const field=root.querySelector(`[data-variant="${dependentLabel}"]`);
      if(!field)return;
      const parentValue=selections[configuration.dependsOn];
      const allowed=configuration.optionsByValue?.[parentValue]||[];
      field.hidden=!parentValue;
      field.querySelectorAll('[data-value]').forEach(button=>{
        const enabled=Boolean(parentValue)&&allowed.includes(button.dataset.value);
        button.hidden=Boolean(parentValue)&&!enabled;
        button.disabled=!enabled;
      });
      if(selections[dependentLabel]&&!allowed.includes(selections[dependentLabel])){
        delete selections[dependentLabel];
        field.querySelectorAll('[data-value]').forEach(button=>button.classList.remove('active'));
        field.querySelector('[data-variant-value]').textContent='';
        if(primaryVideo&&media[0]?.type==='video'){
          media[0]={...media[0],src:primaryVideo};
          activateMedia(0);
        }
      }
    });
  };
  const purchaseActions=root.querySelector('[data-product-actions]');
  const renderActions=state=>{
    if(!purchaseActions)return;
    const whatsappBase='https://wa.me/523327052074?text=';
    const selected=Object.entries(selections).map(([label,value])=>`${label}: ${value}`).join(' · ');
    if(isCarpas){
      purchaseActions.classList.add('is-single');
      purchaseActions.innerHTML=`<a class="button button-yellow carpas-whatsapp-cta" target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent('Hola ELEVENINE, quiero cotizar una carpa personalizada. Me interesa conocer medidas, materiales, impresión y tiempos de entrega.')}">COTIZAR CON UN ASESOR POR WHATSAPP</a>`;
      return;
    }
    if(isStark){
      purchaseActions.classList.add('is-single');
      purchaseActions.innerHTML=`<a class="button button-yellow quote-whatsapp-cta" target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent(`Hola ELEVENINE, quiero personalizar una ${product.name}. ¿Me ayudan con colores, configuración y disponibilidad?`)}">PERSONALIZAR CON UN ASESOR POR WHATSAPP</a>`;
      return;
    }
    if(isQuoteOnly){
      purchaseActions.classList.add('is-single');
      purchaseActions.innerHTML=`<a class="button button-yellow quote-whatsapp-cta" data-quote-link target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent(`Hola ELEVENINE, quiero cotizar ${product.name} de la línea Accesorios SUR-RON. ¿Me ayudan a confirmar precio, compatibilidad y disponibilidad?`)}">COTIZAR ESTE ACCESORIO POR WHATSAPP</a>`;
      return;
    }
    if(state.mode==='preorder'){
      const message=`Hola ELEVENINE, quiero apartar en preventa ${displayName}.${selected?` Mi selección es ${selected}.`:''} Quiero confirmar el apartado de $50,000 MXN, disponibilidad y siguientes pasos.`;
      purchaseActions.classList.remove('is-single');
      purchaseActions.innerHTML=`<a class="button button-dark" target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent(message)}">${state.cta||'APARTAR EN PREVENTA'}</a><a class="button button-yellow" target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent(message)}">HABLAR CON UN ASESOR</a>`;
      return;
    }
    if(state.mode==='in'){
      purchaseActions.classList.remove('is-single');
      purchaseActions.innerHTML='<button class="button button-dark" type="button" data-add>AÑADIR AL CARRITO</button><button class="button button-yellow" type="button" data-buy>COMPRAR AHORA</button>';
      purchaseActions.querySelector('[data-add]')?.addEventListener('click',()=>add(false));
      purchaseActions.querySelector('[data-buy]')?.addEventListener('click',()=>add(true));
      return;
    }
    purchaseActions.classList.add('is-single');
    purchaseActions.innerHTML=`<a class="button button-yellow" target="_blank" rel="noopener" href="${whatsappBase}${encodeURIComponent('Hola ELEVENINE, quiero consultar disponibilidad de '+product.name+(selected?'. Mi selección es '+selected:'') )}">${product.launch?'CONSULTAR LANZAMIENTO':'CONSULTAR DISPONIBILIDAD'}</a>`;
  };
  const syncAvailabilityUI=()=>{
    const state=selectedAvailabilityState();
    const stockPill=root.querySelector('[data-stock-pill]');
    const noteNode=root.querySelector('[data-availability-note]');
    if(stockPill){
      stockPill.textContent=state.label;
      stockPill.className=`stock-pill ${state.mode==='preorder'?'preorder':(state.mode==='in'?'in':(product.launch?'launch':'out'))}`;
      if(isQuoteOnly)stockPill.className='stock-pill launch';
    }
    if(noteNode){
      noteNode.innerHTML=state.note||'';
      noteNode.classList.toggle('is-preorder',state.mode==='preorder');
    }
    renderActions(state);
  };

  const selectVariant=(field,btn)=>{
    field.querySelectorAll('[data-value]').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    const label=field.dataset.variant;
    const value=btn.dataset.value;
    selections[label]=value;
    field.querySelector('[data-variant-value]').textContent='· '+value;
    errorMessage.textContent='';
    syncVariantDependencies();
    syncCustomizer();
    syncModelYearPanel();
    syncQuoteLink();
    syncVariantDescription();
    syncAvailabilityUI();
    const variantVideo=product.modelVariantVideos?.[lockedModel]?.[label]?.[value]
      ||product.variantVideos?.[label]?.[value];
    if(variantVideo){
      media[0]={...media[0],type:'video',src:variantVideo};
      activateMedia(0);
      return;
    }
    const combinationKey=(product.variantCombinationLabels||[])
      .map(variantLabel=>`${variantLabel}=${selections[variantLabel]||''}`)
      .join('|');
    const variantImage=product.variantCombinationImages?.[combinationKey]
      ||product.variantImages?.[label]?.[value];
    if(variantImage){
      const imageIndex=media.findIndex(item=>item.type==='image'&&item.src===variantImage);
      if(imageIndex>=0){
        activateMedia(imageIndex);
        return;
      }
      const firstImage=media.findIndex(item=>item.type==='image');
      if(firstImage>=0){
        media[firstImage]={...media[firstImage],src:variantImage};
        activateMedia(firstImage);
      }
      return;
    }
    if(!product.variantVideos?.[label])return;
    const imageIndex=media.findIndex(item=>item.type==='image');
    if(imageIndex>=0)activateMedia(imageIndex);
  };
  root.querySelectorAll('[data-variant]').forEach(field=>field.querySelectorAll('[data-value]').forEach(btn=>btn.addEventListener('click',()=>selectVariant(field,btn))));
  customizer?.querySelectorAll('[data-personal-kind]').forEach(button=>button.addEventListener('click',()=>setPersonalizationKind(button.dataset.personalKind)));
  customInput?.addEventListener('input',syncPersonalization);
  customNumber?.addEventListener('input',syncPersonalization);
  syncVariantDependencies();
  const initialSelections=lockedModel
    ?{...(product.modelDefaultSelections?.[lockedModel]||{})}
    :{...(product.defaultSelections||{})};
  if(nativeProduct&&Array.isArray(nativeProduct.variants)){
    const nativeOptionNames=Array.isArray(nativeProduct.options)?nativeProduct.options:[];
    const modelIndex=nativeOptionNames.findIndex(name=>String(name||'').trim().toLocaleLowerCase('es-MX')==='modelo');
    const preferredVariant=(lockedModel&&modelIndex>=0
      ?nativeProduct.variants.find(variant=>variant.available&&String(variant.options?.[modelIndex]??'').trim()===String(lockedModel))
      :nativeProduct.variants.find(variant=>String(variant.id)===String(nativeProduct.selectedVariantId)&&variant.available))
      ||nativeProduct.variants.find(variant=>variant.available)
      ||nativeProduct.variants[0];
    if(preferredVariant){
      nativeOptionNames.forEach((label,index)=>{
        if(!label||label==='Title'||(lockedModel&&String(label).trim().toLocaleLowerCase('es-MX')==='modelo'))return;
        if(initialSelections[label])return;
        const value=String(preferredVariant.options?.[index]??'').trim();
        if(value)initialSelections[label]=value;
      });
    }
  }
  Object.entries(initialSelections).forEach(([label,value])=>{
    [...(root.querySelector(`[data-variant="${label}"]`)?.querySelectorAll('[data-value]')||[])]
      .find(button=>button.dataset.value===value)?.click();
  });
  syncAvailabilityUI();
  syncModelYearPanel();
  syncQuoteLink();
  syncVariantDescription();
  root.querySelectorAll('[data-qty]').forEach(btn=>btn.addEventListener('click',()=>{qty=Math.max(1,Math.min(99,qty+Number(btn.dataset.qty)));root.querySelector('[data-qty-value]').textContent=qty;}));
  async function add(buyNow=false){
    if(personalizedVersion()&&!String(selections.Personalización||'').trim()){
      errorMessage.textContent='Escribe el nombre, número o apodo para personalizar la correa.';
      customInput?.focus();
      return;
    }
    if(personalizedVersion()&&selections['Tipo de personalización']==='Nombre + número'&&!String(selections['Número personalizado']||'').trim()){
      errorMessage.textContent='Agrega también el número que quieres combinar con el nombre.';
      customNumber?.focus();
      return;
    }
    const result=await Cart.add(product,selections,qty);
    if(!result.ok){errorMessage.textContent=result.message;return;}
    location.href=buyNow?'/checkout':'/cart';
  }
  const related=C.products.filter(p=>p.id!==product.id&&p.category===product.category).slice(0,4);
  const fallback=C.products.filter(p=>p.id!==product.id&&p.group===product.group).slice(0,4-related.length);
  root.querySelector('[data-related]').innerHTML=[...related,...fallback].slice(0,4).map(p=>{
    const stockLabel=p.launch?'NUEVO LANZAMIENTO':(p.stock?'EN EXISTENCIA':'AGOTADO');
    const priceLabel=p.category==='STARK VARG'
      ?'PERSONALIZACIÓN POR WHATSAPP'
      :C.priceLabel(p);
    return `<a class="product-card-mini" href="${C.productUrl(p)}"><div>${p.video?`<video class="product-loop" data-product-video muted loop playsinline preload="none" aria-label="Video 360 de ${C.escapeHTML(p.name)}"><source src="${C.escapeHTML(p.video)}" type="video/mp4"></video>`:`<img src="${C.escapeHTML(p.image)}" alt="${C.escapeHTML(p.name)}" loading="lazy">`}<span class="stock-mini">${stockLabel}</span></div><small>${C.escapeHTML(p.category)}</small><h3>${C.escapeHTML(p.name)}</h3><b>${priceLabel}</b><span class="link-arrow">VER PRODUCTO →</span></a>`;
  }).join('');
})();
